import classnames from 'classnames';
import React from 'react';

import NextButton from '../NextButton';
import PreviousButton from '../PreviousButton';

const CSS = require('./SideButtons.module.scss');

function SideButtons({
  prevButtonDisabled,
  nextButtonDisabled,
  previousButtonClassName,
  nextButtonClassName,
  onPrevious,
  onNext,
  isInverted,
}) {
  return (
    <>
      <PreviousButton
        disabled={prevButtonDisabled}
        className={classnames(CSS.PrevButton, {
          [previousButtonClassName]: !!previousButtonClassName,
        })}
        onClick={onPrevious}
        isInverted={isInverted}
      />
      <NextButton
        disabled={nextButtonDisabled}
        className={classnames(CSS.NextButton, {
          [nextButtonClassName]: !!nextButtonClassName,
        })}
        onClick={onNext}
        isInverted={isInverted}
      />
    </>
  );
}

export default SideButtons;
